import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { InventoryTrackingBadgeProps } from "./InventoryTrackingBadge.types"

const icon = faIcon({ name: "shelves", style: "regular" })

export default function InventoryTrackingBadge(props: InventoryTrackingBadgeProps) {
    const { tracksInventory, size = "md" } = props

    return (
        <Badge size={size} variant="icon" icon={icon}>
            {tracksInventory ? "Inventory" : "Non-Inventory"}
        </Badge>
    )
}
